import { DarkButton } from '../../../components/dark-button';
import React from 'react';
import styles from '../page.module.css';

//import styles from './Modal.module.css'; // optional for styling

interface ModalProps {
	show: boolean;
	title?: string;
	message: string;
	precheckinLink: string;
	onClose: () => void;
	buttonText?: string;
	onButtonClick?: () => void;
}

const Modal: React.FC<ModalProps> = ({
	show,
	title,
	message,
	onClose,
	precheckinLink,
	buttonText = 'OK',
	onButtonClick,
}) => {
	if (!show) return null;

	return (
		<div className={styles.modalOverlay}>
			<div className={styles.modalContent}>
				{title && <h5 className="fw-semibold">{title}</h5>}
				<p>{message}</p>
				<div className="d-flex justify-content-center mt-3 theme-footer">
					<DarkButton
						text={buttonText}
						filled
						hideArrow
						onClick={() => {
							if (onButtonClick) onButtonClick();
							onClose();
							console.log('precheckinLink', precheckinLink);
							// if (precheckinLink) window.location.href = precheckinLink;
						}}
					/>
				</div>
			</div>
		</div>
	);
};

export default Modal;
